<template>
    <v-select
        :items="orderedSortingValues"
        item-value="value"
        item-text="text"
        v-model="computedSort"
        dense
        class="sorting-selector"
    />
</template>

<script>
import {mapGetters, mapState} from 'vuex';

export default {
    name: 'SortingSelector',
    props: [
        'value',
    ],
    data() {
        return {
            sort: undefined,
        };
    },
    created() {
        this.$emit('input', this.sortingValues.find((element) => {
            return element.value == this.sort;
        }).text);
    },
    computed: {
        ...mapState('SearchResults', ['lastSearchParams']),
        ...mapGetters('SearchResults', [
            'searchConfig',
            'defaultSorting',
            'sortingValues',
        ]),
        ...mapGetters('SearchFilters', [
            'getCategoryById',
        ]),
        computedSort: {
            get() {
                if (this.routeSorting !== undefined) {
                    return this.routeSorting;
                } else if (this.sort !== undefined) {
                    return this.sort;
                } else {
                    return this.defaultSorting || null;
                }
            },
            set(val) {
                this.sort = val;
            },
        },
        routeSorting() {
            return this.$router.currentRoute.params.sort;
        },
        orderedSortingValues() {
            if (this.defaultSorting !== undefined) {
                return this.sortingValues.sort(
                    (a, b) => a.value === this.defaultSorting ? -1 : (b.value === this.defaultSorting ? 1 : 0)
                );
            } else {
                return this.sortingValues;
            }
        },
    },
    watch: {
        sort: {
            handler(value, oldValue) {
                if (undefined === value && undefined === oldValue) {
                    value = this.defaultSorting;
                }
                this.$emit('input', this.sortingValues.find((element) => {
                    return element.value == value;
                }).text);
                const path = this.$search.getSearchRouteParams({sort: value}, false, true);
                this.$router.push({
                    path
                });
            },
            immediate: true,
        },
        lastSearchParams: {
            deep: true,
            immediate: true,
            handler(newParams, oldParams) {
                if (newParams && oldParams) {
                    const newCategory = newParams.category;
                    const oldCategory = oldParams.category;
                    if (newCategory != oldCategory) {
                        this.sort = this.defaultSorting || null;
                    }
                }
            }
        }
    },
};
</script>